import { Button } from 'primereact/button'
import { InputTextarea } from 'primereact/inputtextarea'
import { useEffect, useState } from 'react'
import Modal from '../../components/popup/Modal'

const HuyCapPhat = (props) => {
  const { id, load, visible, toggle, header } = props
  const [noiDung, setNoiDung] = useState('')

  useEffect(() => setNoiDung(''), [visible])
  const footer = () => (
    <div className="flex justify-content-end w-full pt-2">
      <Button
        label="Huỷ"
        className="p-button-secondary mr-2"
        onClick={() => {
          setNoiDung('')
          if (toggle) toggle()
        }}
      />
      <Button
        onClick={async () => {
          toggle()
          setNoiDung('')
          if (load) load({ noiDung, id })
        }}
        label="Lưu"
      />
    </div>
  )

  return (
    <>
      <Modal header={header || 'Phản hồi'} visible={visible} toggle={toggle} footer={footer}>
        <div className="w-full">
          <InputTextarea
            id="message"
            name="message"
            className="w-full"
            value={noiDung}
            onChange={(event) => setNoiDung(event.target.value)}
            autoResize
          />
        </div>
      </Modal>
    </>
  )
}
export default HuyCapPhat
